/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Role_FsInputs */

const en_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software Developer · Full-Stack`)
};

const ar_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطور برمجيات · حزمة كاملة`)
};

const bn_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সফটওয়্যার ডেভেলপার · ফুল-স্ট্যাক`)
};

const de_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softwareentwickler · Full-Stack`)
};

const es_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador de software · Full-Stack`)
};

const fr_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur de logiciels · Full-Stack`)
};

const pt_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor de software · Full Stack`)
};

const zh_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件开发人员·全栈`)
};

const tr_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılım Geliştiricisi · Tam Yığın`)
};

const ru_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик программного обеспечения · Полный стек`)
};

const pl_resume_role_fs = /** @type {(inputs: Resume_Role_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programista · Pełny stos`)
};

/**
* | output |
* | --- |
* | "Software Developer · Full-Stack" |
*
* @param {Resume_Role_FsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_role_fs = /** @type {((inputs?: Resume_Role_FsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Role_FsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_role_fs(inputs)
	if (locale === "bn") return bn_resume_role_fs(inputs)
	if (locale === "de") return de_resume_role_fs(inputs)
	if (locale === "es") return es_resume_role_fs(inputs)
	if (locale === "fr") return fr_resume_role_fs(inputs)
	if (locale === "pt") return pt_resume_role_fs(inputs)
	if (locale === "zh") return zh_resume_role_fs(inputs)
	if (locale === "tr") return tr_resume_role_fs(inputs)
	if (locale === "ru") return ru_resume_role_fs(inputs)
	if (locale === "pl") return pl_resume_role_fs(inputs)
	return en_resume_role_fs(inputs)
});